import Layout from "../../components/Layout";
import {Link, useNavigate} from "react-router-dom";
import SearchBox from "../../components/SearchBox";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter, faSpinner} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../components/Pagination";
import PriceListTable from "../../components/Tables/PriceListTable";
import {useEffect, useState} from "react";
import FilterBox from "../../components/FilterBox";
import ApiRoute, {shopId} from "../../helper/api";
import CreatePriceListModal from "../../components/PriceList/CreatePriceListModal";
import ShopSelect from "../../components/Shop/ShopSelect";

function PriceList() {
    const navigate = useNavigate()
    const [createModal, setCreateModal] = useState(false)

    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState('0')
    const [shop_id, setShopId] = useState('')
    const [pageNumber, setPageNumber] = useState(1)
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: '',
        by: 'cellphone'
    })
    const [filterQuery, setFilterQuery] = useState({})

    // state tab for filtering
    const [statsTab , setStatsTab] = useState(null)
    const [selectedStatsTab , setSelectedStatsTab] = useState('')

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const  res  = await ApiRoute.priceList.index.fn({
                shop_id: shop_id,
                quick_search : searchQuery,
                page : pageNumber
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);
    // watch searchQuery and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [searchQuery]);

    return (
        <Layout>
            <div>
                <div className="flex items-center justify-between mb-3">
                    <div className="page-title flex-auto ml-3 md:ml-0">
                        <span className="inline-block bg-white pl-3">لیست قیمت ها</span>
                    </div>
                    <button onClick={() => setCreateModal(true)} className="btn-blue text-center md:hidden" > افزودن لیست قیمت جدید</button>
                </div>

                <div className="grid md:flex justify-between items-center gap-3">
                    <div className="flex gap-3">
                        <SearchBox SetSearchQuery={setSearchQuery}/>
                    </div>
                    <button onClick={() => setCreateModal(true)} className="btn-blue !w-max hidden md:block">افزودن لیست قیمت جدید</button>
                </div>

                <div className="my-3">
                    <ShopSelect
                        assignItem={(shop) => {
                            setShopId(shop?._id)
                            setUpdateData(Date.now().toString())
                        }}
                        multiple={false}
                        defaultValue={shop_id}
                    />
                </div>

                <div className="main-content p-1 mt-3">
                    {isLoading ? (
                        <div className="flex justify-center items-center py-10">
                            <FontAwesomeIcon icon={faSpinner} spin className="text-3xl text-purple-600" />
                        </div>
                    ) : (
                        <>
                            {data && <PriceListTable tableData={tableData}/>}
                            {data && <Pagination Data={paginationData} SetPageNumber={setPageNumber}/>}
                        </>
                    )}
                </div>
            </div>

            {createModal && <CreatePriceListModal
                closeModal={ () => {
                    setCreateModal(false);
                } } event={ (res) => {
                    setUpdateData(Date.now().toString())
                    return navigate("/price-list/edit?id="+res.results._id)
                } }/>}

        </Layout>
    )
}

export default PriceList